"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "c-cms-login-image grow lg:ml-4" };
const _hoisted_2 = ["srcset"];
const _hoisted_3 = ["srcset"];
const _hoisted_4 = ["srcset"];
const _hoisted_5 = ["src", "alt"];
const store_1 = require("@/state/store");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ImageLandingPage',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("picture", null, [
                    (0, vue_2.createElementVNode)("source", {
                        srcset: (0, vue_2.unref)(store_1.store).landingPage.desktopImageURL,
                        media: "(min-width: 1024px)"
                    }, null, 8, _hoisted_2),
                    (0, vue_2.createElementVNode)("source", {
                        srcset: (0, vue_2.unref)(store_1.store).landingPage.tabletImageURL,
                        media: "(min-width: 501px) and (max-width: 1023px)"
                    }, null, 8, _hoisted_3),
                    (0, vue_2.createElementVNode)("source", {
                        srcset: (0, vue_2.unref)(store_1.store).landingPage.mobileImageURL,
                        media: "(max-width: 500px)"
                    }, null, 8, _hoisted_4),
                    (0, vue_2.createElementVNode)("img", {
                        class: (0, vue_2.normalizeClass)([[
                                { 'lg:h-[600px]': (0, vue_2.unref)(store_1.store).landingPage.hasHiResImage },
                                { 'lg:min-h-full': !(0, vue_2.unref)(store_1.store).landingPage.hasHiResImage },
                            ], "w-full lg:object-cover"]),
                        src: (0, vue_2.unref)(store_1.store).landingPage.desktopImageURL,
                        alt: (0, vue_2.unref)(store_1.store).landingPage.imageAltText,
                        loading: "lazy"
                    }, null, 10, _hoisted_5)
                ])
            ]));
        };
    }
});
